module.exports = __webpack_public_path__ + "img/joim_resume04@2x.8261331b.png";